import React from 'react';

import { Draggable } from '../DragAndDrop/Draggable';
import { dataHooks } from './constants';

export default Component => props =>
  (
    <div data-hook={props.dataHook}>
      <Draggable.Manager dataHook={dataHooks.provider}>
        <Component {...props} />
      </Draggable.Manager>
    </div>
  );
